import React from 'react';
import styled from 'styled-components';
import { Body5, Container } from '@ui';
import { FlatButton } from '@ui/buttons';
import ErrorText from '@ui/ErrorText';
import { DescriptionInput } from './styles';

const NameInput = styled.input`
  outline: none;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.themeColors.border};
  border-radius: 4px;
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.themeColors.text};
  background-color: transparent;
  padding: 12px 16px;
`;

/**
 * Pure presentational form. All state and submission live in the parent; this
 * component only renders fields and reports changes/submit through callbacks.
 */
export const GeneratorForm = ({
  name,
  description,
  nameError,
  error,
  isGenerating,
  onNameChange,
  onDescriptionChange,
  onSubmit,
}) => {
  return (
    <Container>
      <Container bottom={8}>
        <Body5 bold>Name</Body5>
      </Container>
      <NameInput
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
        placeholder="Bull/Base/Bear Scenarios"
        disabled={isGenerating}
      />
      {nameError && (
        <Container top={8}>
          <ErrorText>{nameError}</ErrorText>
        </Container>
      )}

      <Container top={24} bottom={8}>
        <Body5 bold>Description</Body5>
      </Container>
      <Container bottom={8}>
        <Body5 isLowContrast>
          Describe what the agent should do, step by step. The more specific, the better the generated script.
        </Body5>
      </Container>
      <DescriptionInput
        value={description}
        onChange={(e) => onDescriptionChange(e.target.value)}
        placeholder="Produce three stock scenarios (bull, base, bear) for a ticker, then run a JSON repair pass, then format the result as an analyst write-up with a comparison table."
        disabled={isGenerating}
      />
      {error && (
        <Container top={8}>
          <ErrorText>{error}</ErrorText>
        </Container>
      )}

      <Container top={32} style={{ textAlign: 'center' }}>
        <FlatButton fullWidth disabled={isGenerating} onClick={onSubmit}>
          {isGenerating ? 'Generating...' : 'Generate Agent Script'}
        </FlatButton>
      </Container>
    </Container>
  );
};
